import { useEffect, useState } from 'react'

const DEFAULT_ZOOM = 12
const ADDRESS_ZOOM = 16

type IUseZoomLevel = (searchType: 'address' | 'other') => {
  zoom: number
  onZoomChange: (zoomLevel: number) => void
}

/**
 * Zoom level state
 *
 * Right now, we only use this to auto-zoom in when the user searches for an exact address.
 *
 * In the near future we will also use this to
 * - zoom out in the no results case until we can show some listings on screen
 * - zoom in on listings when the user clicks on a listing in the list view
 */
const useZoomLevel: IUseZoomLevel = searchType => {
  const [zoom, setZoom] = useState<number>(DEFAULT_ZOOM)

  const onZoomChange = (newZoom: number) => setZoom(newZoom)

  useEffect(() => {
    if (searchType === 'address') setZoom(ADDRESS_ZOOM)
  }, [searchType])

  return {
    zoom,
    onZoomChange,
  }
}

export default useZoomLevel
